<template>
    <div>
        <b-progress v-if="showProgressBar"
                    :value="percentCompleted"
                    :max="100"
                    height="3px"
                    variant="danger"
                    class="progress-load">

        </b-progress>

        <div class="selectable-menu" id="selectable-channel" @mouseleave="hideSidebarMenu" @mouseenter="fixSidebarMenu">
            <div v-if="channels.length" v-for="(channel, index) in channels" class="option-channels" @click="changeRadio(channel.id, index)">
                <div class="radio-icon-pause" v-if="player.playing && player.channel === channel.id" @click="pause()">
                    <svg-icon icon="pausa_menu"/>
                </div>
                <div class="radio-icon" v-if="player.channel !== channel.id || !player.playing"
                     @click="play(channel.id, index)">
                    <svg-icon icon="play_podcast-01"/>
                </div>
                <div class="option-info">
                    <p class="option-name-first">Radio</p>
                    <p class="option-name-second">{{channel.name}}</p>
                </div>
            </div>
        </div>

        <carousel ref="carousel"
                  :loop="true"
                  :per-page="1"
                  :pagination-enabled="false"
                  :navigationEnabled="true"
                  :mouse-drag="false"
        >
            <slide v-if="channels.length" v-for="(channel, index) in channels" :key="channel.id" v-cloak>
                <div class="content" @click="hideSidebarMenu">
                    <div class="main">
                        <div class="radio">
                            <div class="top">
                                <div class="top-img">
                                    <svg-icon icon="pausa_krug-01" @click.native="pause()"
                                              v-if="player.playing && player.channel === channel.id && !player.id"/>
                                    <svg-icon icon="play_krug-01" @click.native="play()"
                                              v-if="player.channel !== currentChannelId || !player.playing || player.id"/>
                                </div>

                                <div class="bar-name">
                                    <p class="bar-name-first main-text">Radio</p>
                                    <p class="bar-name-second main-text">{{channel.name}}</p>
                                </div>
                            </div>

                            <radio-song-panel :tracks="tracks" :player="player"/>

                        </div>

                        <div class="podcast">
                            <div class="top">
                                <div class="top-img">
                                    <svg-icon icon="pausa_krug-01" @click.native="pause()"
                                              v-if="player.playing && player.channel === channel.id && player.id"/>
                                    <svg-icon icon="play_krug-01" @click.native="playPodcast()"
                                              v-if="player.channel !== currentChannelId || !player.playing || !player.id"/>
                                </div>
                                <div class="bar-name">
                                    <p class="bar-name-first main-text">Listen and Download</p>
                                    <p class="bar-name-second main-text">{{channel.name}} Podcast</p>
                                </div>
                            </div>

                            <podcast-song-panel ref="podcast" :podcasts="podcasts" :player="player"
                                                :currentChannelId="currentChannelId"/>
                        </div>
                    </div>

                    <div class="bar-next">
                        <div class="bar-next-top">
                            <a href="#" class="arrow">
                                <svg-icon icon="strelka-01" @click.native="changeRadio(issetNextChannel(index).id)"/>
                            </a>
                        </div>

                        <div class="bar-next-name">
                            <p :class="'next' + issetNextChannel(index).id  + ' bar-next-name-first'">Next Radio</p>
                            <p class="bar-next-name-second text">{{issetNextChannel(index).name}}</p>
                        </div>

                        <div class="bottom-menu">
                            <div class="bottom-menu-top">
                                <svg-icon icon="3tochki"/>
                            </div>
                            <div class="bottom-menu-bot">
                                <div class="bottom-menu-am" @click="changeOnLightTheme">AM</div>
                                <div class="bottom-menu-pm" @click="changeOnDarkTheme">PM</div>
                            </div>
                        </div>
                    </div>
                </div>
            </slide>
        </carousel>

        <download-modal/>

    </div>

</template>
<script>

  import DownloadModal from '../components/modals/DownloadModal'
  import SvgIcon from '../components/layout/SvgIcon'
  import RadioSongPanel from '../components/radio/SongPanel'
  import PodcastSongPanel from '../components/podcast/SongPanel'
  import { Carousel, Slide } from 'vue-carousel'
  import { mapGetters } from 'vuex'
  import bProgress from 'bootstrap-vue/es/components/progress/progress'

  import Pusher from 'pusher-js'

  const socket = new Pusher('ce86a7ca00af7fa6aedb', {
    cluster: 'eu',
    encrypted: true
  })
  const channel = socket.subscribe('radio-status-song')

  export default {
    components: {
      SvgIcon,
      Carousel,
      Slide,
      DownloadModal,
      RadioSongPanel,
      PodcastSongPanel,
      bProgress
    },
    computed: {
      ...mapGetters([
        'channel_id',
      ]),
    },

    data () {
      return {
        player: {
          playing: false,
          id: null,
          channel: null,
        },

        tracks: [],
        podcasts: [],
        channels: [],

        currentChannelId: null,
        percentCompleted: 0,
        showProgressBar: false
      }
    },

    methods: {

      hideSidebarMenu () {
        document.getElementById('selectable-channel').style.left = '-19.4vw';
      },
      fixSidebarMenu () {
        let el =  document.getElementById('selectable-channel')
        el.style.left = '0';
      },

      issetNextChannel (index) {
        return this.channels[index + 1] ? this.channels[index + 1] : this.channels[0]
      },

      play (ch_id = null, index = null) {
        if (ch_id && this.currentChannelId !== ch_id) {
          this.changeRadio(ch_id, index)
        }

        this.stopAllTracks()
          console.log(this.player.channel, this.currentChannelId);
        let audio_f = document.getElementById('radio-' + this.player.channel)
        audio_f.pause()
        let audio = document.getElementById('radio-' + this.currentChannelId)
        audio.play()
        this.player.playing = true
        this.player.id = null
        this.player.channel = this.currentChannelId
        this.sendPlayerEvent()
        this.goProgressBar()
      },

      pause () {
        let id = this.player.id ? this.player.id : this.currentChannelId
        let audio = document.getElementById('radio-' + id)
        audio.pause()
        this.player.playing = false
        this.player.id = null
        this.sendPlayerEvent()
      },

      playPodcast () {
        this.$refs.podcast[0].playPodcast(this.podcasts[0])
      },

      stopAllTracks () {
        let sounds = document.getElementsByTagName('audio')
        for (let i = 0; i < sounds.length; i++) {
          sounds[i].pause()
        }
      },

      sendPlayerEvent () {
        this.$root.$emit('radio-play', {
          player: this.player,
          radio: true
        })
      },

      listenPlayerUpdate () {
        this.$root.$on('radio-play', (item) => {
          this.player = item.player
          if(this.player.playing){
            this.goProgressBar()
          }
        })
      },

      loadData () {
        this.$http.post('api/stream/get-history', {
          'channel_id': this.currentChannelId
        })
          .then(response => {
            this.tracks = response.data
          })

        this.$http.get('api/tracks/podcasts/' + this.currentChannelId)
          .then(response => {
            this.podcasts = response.data
          })
      },

      listenEvents () {
        let self = this
        channel.bind('end-of-song', function (data) {
          console.log(data.track.channel_id + '-----' + self.currentChannelId)
          if (data.track.channel_id == self.currentChannelId) {
            self.loadData()
          }
        })
      },

      setCurrentChannel (id) {
        this.$store.commit('updateChannel', id ? id : this.channels ? this.channels[0].id : 1)
      },

      changeRadio (id, index = null) {
        const carousel = this.$refs.carousel
        const currentPage = carousel.currentPage
        const pageCount = carousel.pageCount
        if (index === 0 || index > 0) {
          carousel.goToPage(index)
          carousel.currentPage = index
        } else {
          currentPage < pageCount - 1 ? carousel.goToPage(currentPage + 1) : carousel.goToPage(0)
        }
        this.currentChannelId = id
        this.setCurrentChannel(id)
        this.loadData()
      },

      getAllChannels () {
        this.$http.get('/api/channels')
          .then(response => {
            this.channels = response.data
              if (!Array.isArray(this.channels) || !this.channels.length) {
                  return;
              }
              if (!this.currentChannelId) {
                  this.currentChannelId = this.channels[0].id;
                  this.player.channel = this.currentChannelId;
              }
              this.loadData();
          })
      },

      changeOnDarkTheme () {
        let app = document.getElementById('app')
        app.classList.add('dark-theme')
      },

      changeOnLightTheme () {
        let app = document.getElementById('app')
        app.classList.remove('dark-theme')
      },

      goProgressBar () {
        this.showProgressBar = true
        this.percentCompleted = 0
        let total=0,
          self = this

        let id = setInterval(function(){
          if(total > 5000){
            clearInterval(id)
            self.showProgressBar = false
            self.percentCompleted = 0
          } else{
            total+=250
            self.percentCompleted =  Math.round((total * 100) / 5000)
          }
        }, 250);
      },

    },

    mounted () {
      this.goProgressBar()
      this.listenPlayerUpdate()

      this.getAllChannels()

      this.listenEvents()
    }

  }
</script>


// WEBPACK FOOTER //
// resources/assets/js/views/Home.vue